// The user turn seeded when someone points at a value and asks for it to be
// explained. Kept pure so the wording is unit-testable: the FOCUS block carries
// the structured detail, so this only has to read naturally in the transcript
// and name the gadget the server pins.
const buildExplainValueQuestion = ({
  metricNames,
  valueLabel,
  gadgetTitle,
}: {
  metricNames: string[];
  // The clicked member as displayed ("Dallas", "Jun 2026"); absent for a
  // single-figure gadget.
  valueLabel?: string;
  gadgetTitle: string;
}): string => {
  const subject =
    metricNames.length === 1 ? `the ${metricNames[0]} value` : 'the values';
  const where = valueLabel ? ` for ${valueLabel}` : '';
  return `Explain ${subject}${where} in "${gadgetTitle}"`;
};

export default buildExplainValueQuestion;
